<template>
    <div class="add-container">
        <h3 class="add-container__title">{{ $t('productDetail.accessories') }}</h3>
        <ul class="add-products">
            <template v-for="(product, i) in products" :key="i">
                <li v-if="i < maxItemsToDisplay" :key="i" class="add-products__item">
                    <nuxt-link :to="product.url" class="add-products__item__name">
                        <div class="add-products__item__image-container">
                            <img
                                :src="product.imageCdn"
                                :alt="product.name"
                                width="26"
                                height="26"
                                class="add-products__item__thumbnail"
                                loading="lazy"
                            />
                        </div>
                        <span>{{ product.name }}</span>
                    </nuxt-link>
                    <div class="add-products__item__footer">
                        <div class="add-products__item__price notranslate">{{ $formatCurrency(product.price) }}</div>
                        <ElementsButtonAddBasket
                            class="add-products__item__btn"
                            :alert-cart-show="false"
                            :title="$t('product.buyMore')"
                            :add-basket-align="``"
                            :button-class="`btn-outline-primary add-cart__md`"
                            :product="product"
                            :product-id="product.id"
                            :product-price="product.price"
                            :is-preorder="product.isPreorder"
                            :max-amount-per-order="product.attributes.maxAmountPerOrder"
                            :has-substitution-modal="product.substitutions?.isModal || false"
                        />
                    </div>
                </li>
            </template>
        </ul>
    </div>
</template>

<script lang="ts">
import { PropType } from 'vue'
import Product from '~/models/Product/Product'

export default {
    props: {
        products: {
            type: Array as PropType<Product[]>,
            required: true,
        },
        maxItemsToDisplay: {
            type: Number,
            default: 3,
        },
    },
}
</script>

<style lang="scss" scoped>
.add-container {
    margin-top: 15px;

    @include screen-lg {
        padding: 1.5em;
        box-shadow: $box-shadow;
        border-radius: 10px;
    }

    &:deep(.add-cart) {
        width: 110px;
    }

    &__title {
        font-size: 14px;
        font-weight: 600;
        margin: 0;
        margin-bottom: 10px;
    }
}

.add-products {
    padding: 0;
    margin: 0;

    &__item {
        display: flex;
        font-size: 12px;
        line-height: 14px;
        flex-direction: column;
        padding: 0;
        text-align: left;
        vertical-align: middle;
        margin: 10px 0 0;

        @include screen-lg {
            flex-direction: row;
            margin: 5px 0 0;
        }

        &__footer {
            display: flex;
            min-width: 190px;
        }

        &__btn {
            display: flex;
            align-self: center;
        }

        &__name {
            line-height: 16px;
            color: $color-cta;
            display: flex;
            margin: 0 0 9px;

            @include screen-lg {
                margin: 0;
            }
        }

        &__image-container {
            align-items: center;
            display: flex;
            justify-content: center;
            margin-right: 10px;
            width: 26px;
            height: 26px;
            align-self: center;
        }

        &__thumbnail {
            max-width: 26px;
            max-height: 26px;
            width: 26px;
        }

        &__price {
            align-self: center;
            flex-shrink: 0;
            flex-grow: 1;
            text-align: left;
            font-size: 14px;
            padding: 0 15px;
            margin-left: 22px;

            @include screen-lg {
                text-align: right;
                margin-left: 0px;
            }
        }
    }
}
</style>
